import { Injectable } from '@angular/core';

import { PouchdbService } from '../shared/pouchDb.service'
import { ShelfValues, bookCategoeyEnums } from '../shared/models/shelfEnums';
import { Book } from '../shared/models/book';
import { Constants } from '../shared/models/constants';
import { BookData } from '../shared/models/bookData';
import { storeFavourites } from '../shared/models/storeFavourites';
import { storeRecents } from '../shared/models/storeRecents';
import { storeSearchRecents } from '../shared/models/storeSearchRecents';
import * as _ from 'lodash';
import { IS_ElectronService } from '../shared/IS_Electron.service';

@Injectable()
export class StorePouchDb {
    localDB; remoteDB; storecompThis; bookTypes; subBooksStore;

    constructor(public pouchService: PouchdbService, private ElectronService: IS_ElectronService) {
        this.localDB = pouchService.localDB;
    }
    ngOnInit() {

    }

    getStoreData(storecompThis) {

        this.storecompThis = storecompThis;


        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'store' },

        }).then(function (result) {
            //self.storecompThis.storesListArray = result.docs; 

            // yo, a result
        }).catch(function (err) {
            // ouch, an error
        });
    }

    findSubStores(store) {
        let self = this;

        this.pouchService.localDB.find({
            selector: { type: 'store', storeType: 'sub store', _id: { $in: store.childrenStores } },

        }).then(function (result) {
            self.storecompThis.subStoreArray = result.docs;
            // yo, a result
        }).catch(function (err) {
            // ouch, an error
        });
    }

    findStoreDetails(store) {
        let self = this;

        this.pouchService.localDB.find({
            selector: { type: 'store.storeDetails', _id: { $in: store.storeDetails } },

        }).then(function (result) {

            self.bookTypes = result.docs;
            self.storecompThis.bookTypes = result.docs;

            self.onSelectChange({ index: 0 });

        }).catch(function (err) {
        });
    }

    onSelectChange(evt) {
        let self = this;

        this.pouchService.localDB.find({
            selector: { type: 'book', _id: { $in: this.bookTypes[evt.index].books } },

        }).then(function (result) {

            self.subBooksStore = result.docs;
            self.storecompThis.subBooksStore = result.docs;

        }).catch(function (err) {
        });
    }

    getBookObject(id, compSelf) {
        let self = this;

        this.pouchService.localDB.find({
            selector: { type: 'book', _id: id },

        }).then(function (result) {

            compSelf.openBookObject(result.docs[0])

        }).catch(function (err) {
        });
    }



    getBookData(self, list) {
        var _that = this;
        // if (!this.pouchService.localDB) {
        this.pouchService.localDB = this.pouchService.localDB
        // }

        this.pouchService.localDB.find({
            selector: { type: 'shelf', _id: list._id },
        }).then(function (res) {

            _that.pouchService.localDB.find({
                selector: { type: 'book', _id: { $in: res.docs[0].bookIds } },
            }).then(function (result) {

                self.downloadedBooks(result.docs)
            }).catch(function (err) {
            });
        })

    }



    saveBookToPurchases(book) {
        var bookObj = new Book();

        if (this.ElectronService.IS_ELECTRON) {
            if (localStorage.userData == 'undefined')
                var bookPath = 'assets/Nooor/Default' + '/' + book.publishId;
            else
                var bookPath = 'assets/Nooor/' + this.ElectronService.USER_ID + '/' + book.publishId;

            bookObj.url = bookPath + '/Pdf.pdf';
            bookObj.coverPage = bookPath + "/cover.png";
        }
        else {
            bookObj.url = book.previewUrl;
            bookObj.coverPage = book.thumbnailUrl;
        }


        if (book.type == 'LIQUID') {
            bookObj.bookType = bookCategoeyEnums.NewElesson;

        }
        else if (book.type == 'OLDELE') {
            bookObj.bookType = bookCategoeyEnums.OldElesson;
        }

        else {
            bookObj.bookType = bookCategoeyEnums.pdf;
            if (bookObj.url == "" || bookObj.url == undefined || bookObj.url == 'undefined') {
                bookObj.url = "http://hyd.semanooor.com/NooorM/Pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Pdf.pdf";
            }
        }

        bookObj.bookCategory = ShelfValues.Purchases;
        bookObj.owner = Constants.USER;
        bookObj.bId = book.publishId;
        bookObj._id = Constants.USER + "." + bookObj.bId + ".book";
        bookObj.title = book.title;
        bookObj.author = book.author;
        bookObj.description = book.description;
        bookObj.downloadUrl = book.zipUrl;
        bookObj.downloadThumbnailUrl = book.thumbnailUrl;
        bookObj.price = book.price;
        bookObj.language = book.language;
        bookObj.pageCount = book.pageCount;

        // bookObj.type = book.type;

        var bookDataObj = new BookData();
        bookDataObj._id = Constants.USER + "." + bookObj.bId + ".bookData";
        bookDataObj.bookDocId = bookObj._id;

        bookObj.bookDataDocId = bookDataObj._id;

        var self = this;

        return new Promise((resolve, reject) => {
            self.pouchService.localDB.find({
                selector: { type: 'shelf', category: ShelfValues.Purchases },
            }).then(function (doc) {

                console.log("doc.docs[0].bookIds");
                console.log(doc.docs[0].bookIds);


                doc.docs[0].bookIds.splice(0, 0, bookObj._id);
                //to remove duplicates
                let unique_array = []
                for (let i = 0; i < doc.docs[0].bookIds.length; i++) {
                    if (unique_array.indexOf(doc.docs[0].bookIds[i]) == -1) {
                        unique_array.push(doc.docs[0].bookIds[i]);
                    }
                }
                doc.docs[0].bookIds = unique_array;
                //











                // let bookIdInd = doc.docs[0].bookIds.indexOf(bookObj._id);
                // if (bookIdInd == -1) {
                //     doc.docs[0].bookIds.splice(0, 0, bookObj._id);
                // }

                // doc.docs[0].bookIds.push(bookObj._id);

                return self.pouchService.localDB.put(doc.docs[0]);
            }).then(function (response) {
            }).catch(function (err) {
                console.log(err);
            });

            //To put the document only if no other document with same _id is present 
            self.pouchService.localDB.get(bookObj._id).then(function (doc) {
                console.log("doc already present");
                console.log(doc);
                reject(book);
            }).catch(function (err) {
                console.log(err);
                console.log("no docs");

                self.pouchService.localDB.put(bookObj).then(function (response) {
                    console.log("dadas");
                }).catch(function (err) {
                    console.log(err);
                });

                self.pouchService.localDB.put(bookDataObj).then(function (response) {
                    let obj = {
                        'bookObj': bookObj,
                        'bookDataObj': bookDataObj
                    }
                    resolve(obj);
                }).catch(function (err) {
                    console.log(err);
                    reject(book);
                });

            });
            //

        })
    }

    isFavStortesAvailable() {
        var self = this;
        // this.localDB = this.pouchService.localDB;
        var storeFavs = new storeFavourites();
        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'storeFavorites' },
            }).then(function (result) {
                if (!result.docs.length) {
                    self.pouchService.localDB.put(storeFavs).then(function (res) {
                        var temp = [];
                        resolve(temp);
                    }).catch(function (error) {

                    })
                } else {
                    resolve(result.docs[0].storeIds);
                }
            });
        })
    }
    isRecentStoresAvailable() {
        var self = this;
        // this.localDB = this.pouchService.localDB;
        var recentstore = new storeRecents();
        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'storeRecents' },
            }).then(function (result) {
                if (!result.docs.length) {
                    self.pouchService.localDB.put(recentstore).then(function (res) {
                        var temp = [];
                        resolve(temp);
                    })
                } else {
                    resolve(result.docs[0].storeIds);
                }
            });
        })
    }

    favouriteStoreIds(store) {
        // this.localDB = this.pouchService.localDB
        var self = this;

        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'storeFavorites' },
            }).then(function (result) {
                var favIds = [];
                if (result.docs.length) {
                    let index = _.findIndex(result.docs[0].storeIds, function (o: any) { return o == store.storeId; });
                    if (index != -1) {
                        result.docs[0].storeIds.splice(index, 1)
                    }
                    else {
                        result.docs[0].storeIds.push(store.storeId);
                    }
                    favIds = result.docs[0].storeIds;
                    self.pouchService.localDB.put(result.docs[0]).then(function (res) {
                        resolve(favIds);
                    })
                } else {
                    favIds = [];
                    resolve(favIds);
                }
            })
        });
    }


    addStoreIntoRecents(store) {

        // this.localDB = this.pouchService.localDB
        var self = this;

        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'storeRecents' },
            }).then(function (result) {
                var recentIds = [];
                if (result.docs.length) {
                    let index = _.findIndex(result.docs[0].storeIds, function (o: any) { return o == store.storeId; });
                    if (index == -1) {
                        result.docs[0].storeIds.push(store.storeId);
                    }
                    else {
                        result.docs[0].storeIds.splice(index, 1)
                        result.docs[0].storeIds.push(store.storeId);
                    }
                    recentIds = result.docs[0].storeIds;
                    self.pouchService.localDB.put(result.docs[0]).then(function (res) {
                        resolve(recentIds);
                    })
                } else {
                    recentIds = [];
                    resolve(recentIds);
                }
            })
        });
    }

    isRecentStoreSearchesAvailable() {
        let self = this;
        let storeRecentSearches = new storeSearchRecents();
        storeRecentSearches._id = Constants.USER + '.storeSearchRecents'

        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'storeSearchRecents' },
            }).then(function (result) {
                if (result.docs.length) {
                    resolve(result.docs[0].recentlySearched);
                } else {
                    self.pouchService.localDB.put(storeRecentSearches).then(function (res) {
                        resolve([]);
                    })
                }
            })
        })
    }

    addSearchedItemIntoRecentSearches(item) {
        let self = this;
        return new Promise((resolve, reject) => {
            this.pouchService.localDB.find({
                selector: { type: 'storeSearchRecents' },
            }).then(function (result) {
                let ind = _.findIndex(result.docs[0].recentlySearched, function (o: any) { return o == item; });
                if (ind != -1) {
                    result.docs[0].recentlySearched.splice(ind, 1);
                }

                if (result.docs[0].recentlySearched.length >= 20) {
                    result.docs[0].recentlySearched.splice(0, 1);
                }
                result.docs[0].recentlySearched.push(item)
                let listOfItems = result.docs[0].recentlySearched
                self.pouchService.localDB.put(result.docs[0]).then(function (res) {
                    resolve(listOfItems);
                })

            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/store/store.pouchdb.service.ts